import { EntityTypeChip } from "@/components/chips";
import { usePageTitle } from "@/utilities";
import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  TextInput,
  useTranslate,
} from "react-admin";

const EntitiesList: React.FC = () => {
  const translate = useTranslate();
  usePageTitle(translate("ra.users.pageTitle"));

  const entityFilters = [
    <TextInput source="q" label="ra.gameoo.searchPlaceholder" alwaysOn />,
  ];

  return (
    <List filters={entityFilters} sort={{ field: "created_at", order: "DESC" }}>
      <Datagrid>
        <TextField source="name" label="ra.entities.fullName" />
        <TextField source="pseudo" label="ra.entities.pseudo" />
        <EntityTypeChip source="type" />
        <DateField
          source="created_at"
          label="ra.entities.createdAt"
          options={{ year: "numeric", month: "long", day: "2-digit" }}
        />
      </Datagrid>
    </List>
  );
};

export default EntitiesList;
